export function useCloseTopModal() {
  const overlay = useOverlay()
  const modalStore = useModalStore()

  function closeTopModal(): boolean {
    const openOverlays = overlay.overlays.filter(o => o.isOpen)
    const top = openOverlays[openOverlays.length - 1]
    if (top) {
      overlay.close(top.id)
      return true
    }

    if (modalStore.showSearchModal) {
      modalStore.showSearchModal = false
      return true
    }

    return false
  }

  return { closeTopModal }
}
